// eslint-disable-next-line filenames/no-index
export { config } from './config.js'
export { template } from './template.js'
